import React from "react";
import { Button, Col, Offcanvas, Row } from "react-bootstrap";

import EditableDetail from "../../utils/EditableDetail";
import SpecialtySelect from "../../utils/SpecialtySelect";
import { PanelField } from "../header/HeaderParts";
import PracticePocsEditor from "./PracticePocsEditor";

const PracticeEditPanel = ({
  show,
  data,
  localData,
  onValueChanged,
  onSave,
  onCancel,
  forceSpecialtyRefresh,
  selectedSpecialties,
  onSpecialtiesChanged,
}) => {
  return (
    <Offcanvas show={show} onHide={onCancel} placement="end" className="provider-edit-panel">
      <Offcanvas.Header closeButton>
        <div>
          <Offcanvas.Title as="h5" className="mb-0">Edit {data.name}</Offcanvas.Title>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <PanelField label="Practice name"><EditableDetail originalValue={localData.name} width="100%" name="name" onValueChanged={onValueChanged} /></PanelField>

        <PanelField label="Specialties">
          <SpecialtySelect path="practice" forceRefresh={forceSpecialtyRefresh} handleSpecialtiesChanged={onSpecialtiesChanged} selectedSpecialties={selectedSpecialties} />
        </PanelField>

        <Row>
          <Col><PanelField label="Phone"><EditableDetail originalValue={localData.phone1} width="100%" mask="(999) 999-9999" name="phone1" onValueChanged={onValueChanged} /></PanelField></Col>
          <Col><PanelField label="Fax"><EditableDetail originalValue={localData.fax} width="100%" mask="(999) 999-9999" name="fax" onValueChanged={onValueChanged} /></PanelField></Col>
        </Row>
        <PanelField label="Email"><EditableDetail originalValue={localData.email1} width="100%" name="email1" onValueChanged={onValueChanged} /></PanelField>
        <PanelField label="TIN"><EditableDetail originalValue={localData.tin} width="100%" mask="999999999" name="tin" onValueChanged={onValueChanged} /></PanelField>

        <PanelField label="Points of contact">
          <PracticePocsEditor pocs={localData.practicePocs} onChange={(pocs) => onValueChanged("practicePocs", pocs)} />
        </PanelField>

        <PanelField label="Notes">
          <EditableDetail originalValue={localData.notes} width="100%" name="notes" inputType="textarea" onValueChanged={onValueChanged} />
        </PanelField>
      </Offcanvas.Body>
      <div className="provider-edit-panel-footer">
        <Button variant="outline-secondary" onClick={onCancel}>Cancel</Button>
        <Button variant="primary" onClick={onSave}>Save changes</Button>
      </div>
    </Offcanvas>
  );
};

export default PracticeEditPanel;
